import {aGenericError} from '@modifi/redux'
import {createSelector} from 'reselect'
import {getAuthenticatedAdminAresClient} from '@modifi/trade-api-clients'

const ACTION_LINK_DOCUMENT_TO_TRANSACTION_PENDING =
  'order-details/documents/LINK_DOCUMENT_TO_TRANSACTION_PENDING'
const ACTION_LINK_DOCUMENT_TO_TRANSACTION_SUCCESS =
  'order-details/documents/LINK_DOCUMENT_TO_TRANSACTION_SUCCESS'
const ACTION_LINK_DOCUMENT_TO_TRANSACTION_ERROR =
  'order-details/documents/LINK_DOCUMENT_TO_TRANSACTION_ERROR'
const ACTION_LINK_DOCUMENTS_TO_TRANSACTION_CLEANUP =
  'order-details/documents/LINK_DOCUMENTS_TO_TRANSACTION_CLEANUP'

const initialState = {
  inProgress: 0,
  error: false,
  errors: [],
}

export default (state = initialState, {type, payload}) => {
  switch (type) {
    case ACTION_LINK_DOCUMENT_TO_TRANSACTION_PENDING: {
      return {
        ...state,
        inProgress: state.inProgress + 1,
      }
    }
    case ACTION_LINK_DOCUMENT_TO_TRANSACTION_SUCCESS: {
      return {
        ...state,
        inProgress: state.inProgress - 1,
      }
    }
    case ACTION_LINK_DOCUMENT_TO_TRANSACTION_ERROR: {
      const {message, code} = payload
      return {
        ...state,
        inProgress: state.inProgress - 1,
        error: true,
        errors: [
          ...state.errors,
          {
            errorMessage: message,
            errorCode: code,
          },
        ],
      }
    }
    case ACTION_LINK_DOCUMENTS_TO_TRANSACTION_CLEANUP: {
      return {
        ...initialState,
      }
    }
    default:
      return state
  }
}

const sendLinkDocumentToTransactionRequest = (transactionId, fileId, documentType) => {
  const client = getAuthenticatedAdminAresClient()
  return client.BankTransactions.addDocument({
    transactionId,
    body: {
      documentType,
      fileId,
    },
  }).then(res => res.data())
}

const baseSelector = state => state.modules.link
export const selectIsLinkDocumentsFromTransactionInProgress = createSelector(
  baseSelector,
  link => link.inProgress > 0
)
export const selectIsLinkDocumentsFromTransactionError = createSelector(
  baseSelector,
  link => link.error
)
export const selectLinkDocumentsFromTransactionErrors = createSelector(
  baseSelector,
  link => link.errors
)

export const aLinkDocumentRefToTransaction =
  (transactionId, {fileId, documentType}) =>
  async dispatch => {
    dispatch({
      type: ACTION_LINK_DOCUMENT_TO_TRANSACTION_PENDING,
      payload: {transactionId},
    })

    try {
      await sendLinkDocumentToTransactionRequest(transactionId, fileId, documentType)
    } catch (e) {
      dispatch(aGenericError(ACTION_LINK_DOCUMENT_TO_TRANSACTION_ERROR, e))
      throw e
    }

    dispatch({
      type: ACTION_LINK_DOCUMENT_TO_TRANSACTION_SUCCESS,
      payload: {},
    })
  }

export const aLinkDocumentToTransactionCleanup = () => ({
  type: ACTION_LINK_DOCUMENTS_TO_TRANSACTION_CLEANUP,
})
